import { Checkbox, CheckboxGroup, CheckboxProps, ContainerProps, VStack } from '@chakra-ui/react';
import React, { FC } from 'react';
import { useController } from 'react-hook-form';

interface IOption {
  label: string;
  value: string | number;
}

interface IRadioFieldMultipleProps extends CheckboxProps {
  options: IOption[];
  name: string;
  control: any;
  containerProps?: ContainerProps;
}

const RadioFieldMultiple: FC<IRadioFieldMultipleProps> = ({
  options,
  name,
  control,
  containerProps,
  ...props
}) => {
  const {
    field: { onChange, value },
  } = useController({
    name,
    control,
  });

  return (
    <CheckboxGroup
      value={value}
      onChange={onChange}
    >
      <VStack
        alignItems='start'
        {...containerProps}
      >
        {options?.map((option) => (
          <Checkbox
            key={`${name}_${option?.value}`}
            as='div'
            colorScheme='primary'
            gap='sm'
            size='lg'
            value={option.value}
            {...props}
          >
            {option.label}
          </Checkbox>
        ))}
      </VStack>
    </CheckboxGroup>
  );
};

export default RadioFieldMultiple;
